import { get } from 'lodash';
import { getWixP } from '../../selectors/wix-params-selectors';
export var getAppSettingsValue = function (_a) {
    var style = _a.style, key = _a.key, _b = _a.fallback, fallback = _b === void 0 ? true : _b, _c = _a.isMobileSettingsValue, isMobileSettingsValue = _c === void 0 ? false : _c, _d = _a.useDesktopFallback, useDesktopFallback = _d === void 0 ? true : _d;
    return get(style, getWixP(key, isMobileSettingsValue), useDesktopFallback ? get(style, getWixP(key, false), fallback) : fallback);
};
//# sourceMappingURL=app-settings-selectors.js.map